/* eslint-disable no-underscore-dangle */
import L from 'leaflet';
import { Meteor } from 'meteor/meteor';
import QRCode from 'qrcode';

const SVG_QR = '<img src="/maps-buttons/qr.svg" style="height:100%;width:100%;" />';
const CONTAINER_STYLE = `
  position: relative;
  width: 34px;
  height: 34px;
  cursor: pointer;
`;

const QR_CONTAINER_STYLE = `
  position: absolute;
  padding: 0;
  top: 17px;
  left: 30px;
  z-index: -1;
  max-width: 0px;
  max-height: 0px;
  overflow: hidden;
  transition: max-width 0.2s, max-height 0.2s;
`;

const CANVAS_STYLE = `
  height: auto;
  max-width: 40vw;
`;

L.Control.QRButton = L.Control.extend({
  options: {
    position: 'topleft',
    coordinates: null,
    zoom: null
  },

  onAdd(map) {
    // eslint-disable-next-line no-param-reassign
    map.qrControl = this;
    this.container = L.DomUtil.create('div');
    this.qrContainer = L.DomUtil.create('div', 'alert-light');
    const { container, qrContainer } = this;
    const { publicId, type, sharedPrivate } = this.options;
    let shareConfig;

    if (sharedPrivate === true) {
      shareConfig = 'sharedPrivate';
    } else {
      shareConfig = 'shared';
    }

    map.on('click', this.hideQR, this);
    map.on('mouseout', this.hideQR, this);

    container.innerHTML = SVG_QR;
    container.title = 'QR Code';
    container.style.cssText = CONTAINER_STYLE;
    container.clicked = false;
    container.appendChild(qrContainer);
    qrContainer.style.cssText = QR_CONTAINER_STYLE;

    QRCode.toCanvas(
      `${Meteor.absoluteUrl(`${shareConfig}/${type}s/${publicId}`)}`,
      { errorCorrectionLevel: 'H' },
      (err, canvas) => {
        if (err) throw new Error(err);
        // We need the reasign because we can't clone it and have to change the style
        // eslint-disable-next-line no-param-reassign
        canvas.style.cssText = CANVAS_STYLE;
        qrContainer.appendChild(canvas);
      }
    );

    L.DomEvent.disableClickPropagation(container);
    L.DomEvent.on(container, 'click', L.DomEvent.stop);
    L.DomEvent.on(container, 'click', this.onClick, this);

    return container;
  },

  onClick() {
    if (!this.container.clicked) {
      this.showQR();
    } else {
      this.hideQR();
    }

    return this;
  },

  showQR() {
    this.container.clicked = true;
    L.DomUtil.addClass(this.qrContainer, 'alert');
    const { width } = this.qrContainer.children[0];
    this.qrContainer.style.maxWidth = `${width}px`;
    this.qrContainer.style.maxHeight = `${width}px`;
  },

  hideQR() {
    this.container.clicked = false;
    setTimeout(() => {
      L.DomUtil.removeClass(this.qrContainer, 'alert');
    }, 600);
    this.qrContainer.style.maxWidth = '0px';
    this.qrContainer.style.maxHeight = '0px';
  }
});

L.control.qrbutton = opts => new L.Control.QRButton(opts);

/**
 * Adds a QR code with the url of the public item.
 *
 * @param {object} arg - The arguments object.
 * @param {object} arg.leafletMap - The leaflet map.
 * @param {string} arg.type - The type of the item.
 * @param {string} arg.publicId - The public ID of the item.
 */
const customQRButton = ({ leafletMap, type, publicId, sharedPrivate }) => {
  L.control.qrbutton({ publicId, type, sharedPrivate }).addTo(leafletMap);
};

export default customQRButton;
